import { render } from "./PlotTaskItemListWidget.vue?vue&type=template&id=5cf6e35a&ts=true"
import script from "./PlotTaskItemListWidget.ts?vue&type=script&lang=ts&external"
export * from "./PlotTaskItemListWidget.ts?vue&type=script&lang=ts&external"

import "./PlotTaskItemListWidget.vue?vue&type=style&index=0&id=5cf6e35a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__